<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <a v-bind="attrs" v-on="on">modifier</a>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Modifier votre email
        </v-card-title>

        <v-card-text>
          <div>
            <v-text-field
              class=""
              label="E-mail"
              color="primary"
              append-icon="mdi-email"
              v-model="newEmail"
              :error-messages="newEmailErrors"
              @input="$v.newEmail.$touch()"
              @blur="$v.newEmail.$touch()"
            />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            class="mx-0 font-weight-light secondary"
            text
            @click="onUpdateEmail()"
            >Enregistrer</v-btn
          >
          <v-btn color="primary font-weight-light" text @click="dialog = false">
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    newEmail: { required, email },
  },
  data() {
    return {
      dialog: false,
      newEmail: "",
    };
  },
  mounted() {
    this.newEmail = this.user.mail;
  },
  methods: {
    ...mapActions(["updateUser"]),
    async onUpdateEmail() {
      await this.updateUser(
        JSON.parse(
          JSON.stringify({
            ...this.user,
            newEmail: this.newEmail,
            mailChanged: true,
          })
        )
      );
      this.dialog = false;
    },
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      user: "user",
    }),
    newEmailErrors() {
      const errors = [];
      if (!this.$v.newEmail.$dirty) return errors;
      !this.$v.newEmail.required &&
        errors.push("saisir votre nouveau adresse E-mail");
      !this.$v.newEmail.email && errors.push("email@exemple.com");
      return errors;
    },
  },
};
</script>

<style scoped>
</style>